export const iconFontAwesomeScienceTemperatureLow = (
	<i className="fa-solid fa-temperature-low"></i>
);
